export interface DocumentRectifyModalProps {
  path: string;
  isReceipt: boolean;
}

export enum RectificationType {
  TOTAL = 'total',
  PARTIAL = 'partial',
}
